import React, { useState, useEffect, useRef } from 'react';
import { Tooltip, TooltipProps } from "@fluentui/react-tooltip";

interface ScrollDismissTooltipProps extends TooltipProps {
  children: React.ReactElement;
}

const ScrollDismissTooltip: React.FC<ScrollDismissTooltipProps> = ({ children, ...props }) => {
  const [isVisible, setIsVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => setIsVisible(false);
    window.addEventListener('scroll', handleScroll, true);
    return () => window.removeEventListener('scroll', handleScroll, true);
  }, []);

  return (
    <div ref={ref} onMouseEnter={() => setIsVisible(true)} onMouseLeave={() => setIsVisible(false)} style={{width: "100%"}}>
      <Tooltip {...props} visible={isVisible}>
        {children}
      </Tooltip>
    </div>
  );
};

export default ScrollDismissTooltip;